export const formatIsoDate = (iso: string) => {
	if (!iso) return '—';
	const [year, month, day] = iso.split('T')[0].split('-');
	return `${day}/${month}/${year}`;
};

export const resolveLabel = (options: { value: string; label: string }[], value: string) =>
	options.find((o) => o.value === value)?.label ?? value;

export const formatAnalysisValue = (value?: string | null) =>
	value ? value.replace('.', ',') : value;
